import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
export interface ProjectPhaseActivityState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allProjectPhaseActivity: [] | null | any;
}
const initialState: ProjectPhaseActivityState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allProjectPhaseActivity: null
};
export const projectPhaseActivitySlice = createSlice({
  name: 'projectPhaseActivity',
  initialState,
  reducers: {
    setAllProjectPhaseActivity: (state, action) => {
      state.allProjectPhaseActivity = action.payload.data;
    },
    setProjectPhaseActivity: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllProjectPhaseActivityBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setAllProjectPhaseActivity, setProjectPhaseActivity, setAllProjectPhaseActivityBySearch,reset } = projectPhaseActivitySlice.actions;
export const allProjectPhaseActivityDetails = (state: RootState) => state.projectPhaseActivity.allProjectPhaseActivity;
export const getAllProjectPhaseActivityDetails = (state: RootState) => state.projectPhaseActivity.data;
export const getProjectPhaseActivityTotalRecords=(state:RootState)=>state.projectPhaseActivity.totalRecords;
export const getAllProjectPhaseActivityBySearch = (state: RootState) => state.projectPhaseActivity.data;
export default projectPhaseActivitySlice.reducer;